const isRelevantEntity = (entity, domain, type) =>
  entity.domain === domain && entity.type === type;

const addRelationshipData = (
  sourceEntity,
  targetEntity,
  relationship,
  relationshipsDataMap,
) => {
  const { id } = sourceEntity;
  const { domain, type, id: entityId } = targetEntity;
  if (!relationshipsDataMap[id]) {
    relationshipsDataMap[id] = [];
  }
  relationshipsDataMap[id].push({
    relationshipId: relationship.id,
    domain,
    type,
    entityId,
  });
};

const initRelationshipDataBySource = (
  domain,
  type,
  id,
  relationshipDataBySource,
) => {
  if (!relationshipDataBySource) {
    throw new Error('failed to init relationship data by source');
  }
  if (!relationshipDataBySource[domain]) {
    relationshipDataBySource[domain] = {};
  }
  if (!relationshipDataBySource[domain][type]) {
    relationshipDataBySource[domain][type] = {};
  }
  if (!relationshipDataBySource[domain][type][id]) {
    relationshipDataBySource[domain][type][id] = {};
  }
  if (!relationshipDataBySource[domain][type][id].relationshipsData) {
    relationshipDataBySource[domain][type][id].relationshipsData = [];
  }
};

const getRelationshipsDataMap = (relationships, domain, type) => {
  const relationshipsDataMap = {};
  relationships.forEach((relationship) => {
    // We currently want to handle only 1 to 1 links.
    if (relationship.entities.length === 2) {
      const [first, second] = relationship.entities;
      if (isRelevantEntity(first, domain, type)) {
        addRelationshipData(first, second, relationship, relationshipsDataMap);
      }
      if (isRelevantEntity(second, domain, type)) {
        addRelationshipData(second, first, relationship, relationshipsDataMap);
      }
    }
  });
  return relationshipsDataMap;
};

export const addRelationshipsToState = (
  relationships,
  domain,
  type,
  nextState,
  addFirst,
) => {
  const relationshipDataById = getRelationshipsDataMap(
    relationships,
    domain,
    type,
  );

  relationships.forEach((relationship) => {
    nextState.relationshipsEntityMap[relationship.id] = relationship;
  });

  Object.keys(relationshipDataById).forEach((sourceId) => {
    initRelationshipDataBySource(
      domain,
      type,
      sourceId,
      nextState.relationshipDataBySource,
    );
    const nextStateRelationshipDataBySource =
      nextState.relationshipDataBySource[domain][type][sourceId];
    const existingRelationshipData =
      nextStateRelationshipDataBySource.relationshipsData;
    const getRelationshipId = (source) => source.relationshipId;
    const currentRelationshipIds =
      existingRelationshipData.map(getRelationshipId);
    const newRelationshipIds =
      relationshipDataById[sourceId].map(getRelationshipId);
    const idsInBothCurrentAndNew = currentRelationshipIds.filter(
      (currentRelationshipId) =>
        newRelationshipIds.includes(currentRelationshipId),
    );

    const currentRelationshipData = existingRelationshipData.map(
      (relationship) =>
        idsInBothCurrentAndNew.includes(relationship.relationshipId)
          ? relationshipDataById[sourceId].find(
              ({ relationshipId }) =>
                relationshipId === relationship.relationshipId,
            )
          : relationship,
    );

    const newRelationshipData = relationshipDataById[sourceId].filter(
      (relationship) =>
        !idsInBothCurrentAndNew.includes(relationship.relationshipId),
    );

    nextStateRelationshipDataBySource.relationshipsData = addFirst
      ? [...newRelationshipData, ...currentRelationshipData]
      : [...currentRelationshipData, ...newRelationshipData];
  });
};
